import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  Renderer2
} from '@angular/core';
import { ListComponentGeneric } from '../../../../ui/generics';
import { NotificationService } from '../../../../core/services';
import {
  OrdersService,
  OrdersServiceErrorResolverService,
} from '../../core/services';
import { IDeliveryOrder } from '../../core/interfaces/IDeliveryOrder';
import { IOrderChangeLog } from '../../core/interfaces/IOrderChangeLog';
import { OrderChangeLogActionTypes } from '../../core/enums';
import { ITableResults } from '../../../../core/interfaces';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-order-change-log-list',
    templateUrl: './order-change-log-list.component.html',
    styleUrls: ['./order-change-log-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderChangeLogListComponent extends ListComponentGeneric<IDeliveryOrder> implements OnInit {
  private _orderId: number;

  // @ts-ignore
  public data: ITableResults<IOrderChangeLog> = {
    results: [],
    info: {
      page: 1,
      results: 0,
      totalResults: 0,
      exportTableName: null
    }
  };

  protected readonly exportedTableVisibleName = 'Änderungsprotokoll Bestellung';
  protected readonly defaultSorting = {
    sortField: 'createdAt',
    sortOrder: 'descend'
  };

  @Input() set orderId(val: number) {
    if (val) {
      this._orderId = val;
      this.loadDefault();
    }
  }

  constructor(
    protected _service: OrdersService,
    protected _cdr: ChangeDetectorRef,
    protected _notifyService: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: OrdersServiceErrorResolverService
  ) {
    super(_service, _cdr, _notifyService, renderer, _errorResolver);
  }

  ngOnInit() {}

  load(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    sortOrder: string | null,
    filter: { key: string; value: string[] }[],
    search: { key: string; value: string[] }[],
    additionalFilters: { key: string; value: string[] }[] = [],
  ): void {
    this.lastLoadParams = {
      pageIndex,
      pageSize,
      sortField,
      sortOrder,
      filter,
      search: null,
      additionalFilters
    };
    filter = [...filter, ...this.predefindedFilters];
    this.loading = true;
    this._service.getQueryableOrderChangeLogByOrderId(
      this._orderId,
      pageIndex,
      pageSize,
      sortField ?? this.defaultSorting.sortField,
      sortOrder ?? this.defaultSorting.sortOrder,
      filter
    ).pipe(
      finalize(() => {
        this.loading = false;
        this._cdr.detectChanges();
      })
    ).subscribe(res => this.data = res, this.parseError);
  }

  formatChange(log: IOrderChangeLog): string {
    switch (log.actionType) {
      case OrderChangeLogActionTypes.DocumentUploaded:
        return log.newValue ? `Hochgeladen: ${log.newValue}` : 'Dokument hochgeladen';
      case OrderChangeLogActionTypes.DocumentRemoved:
        return log.oldValue ? `Entfernt: ${log.oldValue}` : 'Dokument entfernt';
      case OrderChangeLogActionTypes.Created:
        return 'Bestellung erstellt';
      case OrderChangeLogActionTypes.LineItemAdded: {
        const added = log.newValue ?? log.entityLabel;
        return added ? `Artikel hinzugefügt: ${added}` : 'Artikel hinzugefügt';
      }
      case OrderChangeLogActionTypes.LineItemRemoved: {
        const removed = log.oldValue ?? log.entityLabel;
        return removed ? `Artikel entfernt: ${removed}` : 'Artikel entfernt';
      }
      default: {
        const oldVal = log.oldValue ?? '—';
        const newVal = log.newValue ?? '—';
        return `${oldVal} → ${newVal}`;
      }
    }
  }
}
